export const COST_BEHAVIOR_OPTIONS = [
  { value: 'fixed', label: 'Fijo' },
  { value: 'variable', label: 'Variable' },
];

export const COST_TRACEABILITY_OPTIONS = [
  { value: 'direct', label: 'Directo' },
  { value: 'indirect', label: 'Indirecto' },
];

export const COST_AREA_OPTIONS = [
  { value: 'work', label: 'Obra' },
  { value: 'administration', label: 'Administración' },
  { value: 'rentals', label: 'Alquileres' },
  { value: 'consortiums', label: 'Consorcios' },
  { value: 'holding', label: 'Holding' },
];

export const CURRENCY_OPTIONS = [
  { value: 'ARS', label: 'ARS' },
  { value: 'USD', label: 'USD' },
];

export const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || value || '-';
